import React, { PureComponent } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { withRouter } from 'react-router-dom';
import { withTheme, Card, CardContent } from '@material-ui/core';
import Background from 'images/background-appmenu.jpg';
import { bindActionCreators } from 'redux';

class ErrorLayout extends PureComponent {
    static propTypes = {
        children: PropTypes.object.isRequired,
        theme: PropTypes.object.isRequired
    };

    render() {
        const { children, theme } = this.props;
        const backgroundStyle = {
            background: `radial-gradient(circle, transparent 80%, black 100%), linear-gradient(to top, ${theme.palette.error.dark} -30%, transparent 50%), url(${Background})`,
            backgroundPosition: 'center center',
            backgroundSize: 'cover',
            backgroundBlendMode: 'overlay',
            position: 'fixed',
            top: '0',
            left: '0',
            width: '100%',
            height: '100%',
            zIndex: '0'
        };
        return (
            <div className="d-flex flex-fill align-items-center justify-content-center" style={backgroundStyle}>
                <Card style={{ minWidth: '50vw', textAlign: 'center' }}>
                    <CardContent>{children}</CardContent>
                </Card>
            </div>
        );
    }
}

function mapStateToProps() {
    return {};
}

export default withRouter(
    connect(
        mapStateToProps,
        dispatch => bindActionCreators(Object.assign({}), dispatch)
    )(withTheme(ErrorLayout))
);



// WEBPACK FOOTER //
// ./layouts/Error/index.js